import React from 'react';

const SvgWw = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="WW_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="WW_svg__b" fill="#fff">
        <use xlinkHref="#WW_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#WW_svg__a" />
      <path fill="#19BFBF" mask="url(#WW_svg__b)" d="M0 0h28v20H0z" />
      <path
        d="M13.614 15.988a6.091 6.091 0 0 0 .772 0c.915-1.085 1.502-3.072 1.6-5.321h-3.972c.098 2.249.685 4.236 1.6 5.32zm-1.831-.411c-.65-1.324-1.03-3.049-1.103-4.91H8.037a6.006 6.006 0 0 0 3.746 4.91zm1.831-11.565c-.915 1.085-1.502 3.072-1.6 5.321h3.972c-.098-2.249-.685-4.236-1.6-5.32a6.091 6.091 0 0 0-.772 0zm-1.831.411a6.006 6.006 0 0 0-3.746 4.91h2.643c.073-1.861.453-3.586 1.103-4.91zm4.434 11.154a6.006 6.006 0 0 0 3.746-4.91H17.32c-.073 1.861-.453 3.586-1.103 4.91zm0-11.154c.65 1.324 1.03 3.049 1.103 4.91h2.643a6.006 6.006 0 0 0-3.746-4.91zM14 17.333a7.333 7.333 0 1 1 0-14.666 7.333 7.333 0 0 1 0 14.666z"
        fill="#FFF"
        mask="url(#WW_svg__b)"
      />
    </g>
  </svg>
);

export default SvgWw;
